import React from 'react';
import '../styles/services.scss'

import nailPolish from '../assets/nail-polish.svg'
import manicure from '../assets/nail.svg'
import slipper from '../assets/slipper.svg'
import cosmetic from '../assets/cosmetics.svg'

const Services = () => (

    <div className="services">
        <div className="services-left">

            <div className="service-left-topside">

                <div className="service-item manicure">
                    <div className="icon-circle">
                        <img src={manicure} width="80" height="80" />
                        <svg height="100" width="100">
                        </svg>
                    </div>
                    <span className="service-description">
                        <h1>Manicure</h1>
                        <p>Our manicure treatments stimulate nail growth and soften dry, dull skin.</p>
                    </span>
                </div>

                <div className="service-item pedicure">
                    <div className="icon-circle">
                        <img src={slipper} width="80" height="80" />
                        <svg height="100" width="100">
                        </svg>
                    </div>
                    <span className="service-description">
                        <h1>Pedicure</h1>
                        <p>Pedicure services provide full restoration for your nails with extra polishing.</p>
                    </span>
                </div>

            </div>

            <div className="service-left-bottomside">
                <div className="service-item nail-art">
                    <div className="icon-circle">
                        <img src={nailPolish} width="80" height="80" />
                        <svg height="100" width="100">
                        </svg>
                    </div>
                    <span className="service-description">
                        <h1>Nail Art</h1>
                        <p>Let our nail artists create a stunning and sustainable nail design for you.</p>
                    </span>
                </div>

                <div className="service-item waxing">
                    <div className="icon-circle">
                        <img src={cosmetic} width="80" height="80" />
                        <svg height="100" width="100">
                        </svg>
                    </div>
                    <span className="service-description">
                        <h1>Waxing</h1>
                        <p>This is a treatment for hands and feet that complements your manicure and pedicure.</p>
                    </span>
                </div>

            </div>
        </div >

        <div className="services-right">
        </div>
    </div >
)


export default Services